<template>
    <div class="order-block d-flex flex-column align-items-center">
     
      <div class="container-property d-flex flex-column">
        <h1 class="title-property">Order Steps</h1>
 <!-- BEGIN BLOCK -->
        <!-- <div class="all-in d-flex flex-row">
          <div class="left-block d-flex flex-column align-items-center">
            <i class="fal fa-map-marker-alt"></i>
            <div class="line-icon"> </div>
          </div>
          <div class="right-block d-flex flex-column" v-if="info.restaurant.id">
            <h1>{{info.restaurant.name}}</h1>
            <p>{{info.restaurant.streetaddress}}</p>
            <p>{{info.restaurant.city}}, {{info.restaurant.state}} {{info.restaurant.zip}}</p>
            <p>{{info.restaurant.telephone}}</p>
          </div>
          <div class="right-block d-flex flex-column" v-else>
            <h1>Restaurant</h1>
            <p>You haven't chosen restaurant yet.</p>
          </div>
          <div class="modify_link d-flex">
            <a href="#" @click="modifyAddress">Modify</a>
          </div>
          
          
        </div> -->
         <div class="all-in d-flex flex-row">
          <div class="left-block d-flex flex-column align-items-center">
            <i class="fal fa-truck"></i>
            <div class="line-icon" v-if="!isSchedulePage"> </div>
          
          </div>
          <div class="right-block d-flex flex-column" v-if="!isSchedulePage && info.method && info.when">
              <h1>{{info.method.charAt(0).toUpperCase() + info.method.slice(1)}}</h1>
              <p>{{info.method.charAt(0).toUpperCase() + info.method.slice(1)}} {{info.when.charAt(0).toUpperCase() + info.when.slice(1)}}</p>
              <p v-if="info.deliveryDate">{{info.deliveryDate.dateName}}, {{info.deliveryDate.monthName}} {{info.deliveryDate.day}}</p>
              <p v-if="info.deliveryDate">{{info.deliveryDate.fullTime}}</p>
              <p v-if="info.when === 'asap'">{{asap}} minutes</p>
              <p v-if="info.method === 'delivery' || info.method === 'dispatch' && info.savedDeliveryAddresses[info.choosedAddressIndex]">{{info.savedDeliveryAddresses[info.choosedAddressIndex].streetaddress}}, {{info.savedDeliveryAddresses[info.choosedAddressIndex].building}}</p>
              <p v-if="info.method === 'delivery' || info.method === 'dispatch' && info.savedDeliveryAddresses[info.choosedAddressIndex]">{{info.savedDeliveryAddresses[info.choosedAddressIndex].city}} {{info.savedDeliveryAddresses[info.choosedAddressIndex].zipcode}}</p>
          </div>
          <div class="right-block d-flex flex-column" v-else>
                <h1>Schedule Order</h1>
                <p>Select a delivery time up to 7 days in advance.</p>
          </div>
          <div class="modify_link d-flex">
            <a href="#" v-if="!isSchedulePage && info.method && info.when" @click="modifyDelivery">Modify</a>
          </div>
          
          
        </div>

        <div class="all-in d-flex flex-row" v-if="!isSchedulePage">
          <div class="left-block d-flex flex-column align-items-center">
            <i class="fal fa-map-marker-alt"></i>
            <div class="line-icon" v-if="!isSearch"> </div>
          </div>
          <div class="right-block d-flex flex-column" v-if="info.restaurant.id">
            <h1>{{info.restaurant.name}}</h1>
            <p>{{info.restaurant.streetaddress}}</p>
            <p>{{info.restaurant.city}}, {{info.restaurant.state}} {{info.restaurant.zip}}</p>
            <p>{{info.restaurant.telephone}}</p>
          </div>
          <div class="right-block d-flex flex-column" v-else>
            <h1>Restaurant</h1>
            <p>You haven't chosen restaurant yet.</p>
          </div>
          <div class="modify_link d-flex" v-if="info.restaurant.id">
            <a href="#" @click="modifyAddress">Modify</a>
          </div>
          
          
        </div>


    <!-- END BLOCK -->
      <div class="all-in d-flex flex-row" v-if="isOrderPage || info.products.length > 0">
          <div class="left-block d-flex flex-column align-items-center">
            <i class="fal fa-shopping-bag"></i>
            <div class="line-icon" v-if="!isOrderPage && info.products.lenght > 4"> </div>
            <p></p>
          </div>
          <div class="right-block d-flex flex-column">
            <h1 style="margin-bottom:0 !important">Order</h1>
            <div v-if="info.products.length > 0">
            <div class="predescription d-flex flex-row justify-content-between align-items-center" v-for="(product, index) in info.products" :key="index">
                
                    <span class="count">{{product.quantity}}</span>
                    <div class="d-flex justify-content-center align-items-center">
                    <p class="preTitle">{{product.product.name}}</p>
                    <!-- <p class="preInfo"> Single, Ketchup, Mayo, Steak Sauce</p> -->
                    </div>
                    <div class="d-flex flex-row justify-content-around align-items-center" style="width:200px">
                    <i class="fal fa-trash" style="padding-right:20px;" @click="trashProduct(index)"></i>
                    <span>${{product.product.cost}}</span>
            </div>
                </div>
            </div>
            <p v-else>Browse menu and add items <br/> that you want to get.</p>
            
          </div>
          <div class="modify_link d-flex" v-if="info.products.length > 0">
            <a href="#" @click="modifyOrder">Modify</a>
          </div>
          
          
        </div>
        <div class="all-in d-flex flex-row" v-if="isPaymentPage || info.paymentMethod">
          <div class="left-block d-flex flex-column align-items-center">
           <i class="fal fa-credit-card-front"></i>
            <div class="line-icon" v-if="!isPaymentPage"> </div>
          </div>
          <div class="right-block d-flex flex-column" v-if="info.paymentMethod">
            <h1>Payment Method</h1>
              <p v-if="info.paymentMethod === 'cash'">Cash</p>
              <div v-else>
              <p>Credit Card</p>
              <p v-if="info.savedCardDetails[info.choosedCardIndex]">{{getCardInfo(info.savedCardDetails[info.choosedCardIndex].cardnumber).niceType}}</p>
              <div class="container-number d-flex flex-row justify-content-between" v-if="info.savedCardDetails[info.choosedCardIndex]">
                <div class="d-flex flex-row align-items-center">
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
                </div>
                <div class="d-flex flex-row align-items-center">
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
                </div>
                <div class="d-flex flex-row align-items-center">
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
                <span class="lastnum">{{info.savedCardDetails[info.choosedCardIndex].cardnumber.slice(info.savedCardDetails[info.choosedCardIndex].cardnumber.length - 5, info.savedCardDetails[info.choosedCardIndex].cardnumber.length)}}</span>
                </div>
                </div>
            </div>
          </div>
          <div class="right-block d-flex flex-column" v-else>
            <h1>Payment Method</h1>
            <p>Select a valid payment method to continue.</p>
            
          </div>
          <div class="modify_link d-flex" v-if="info.paymentMethod">
            <a href="#" @click="modifyCard">Modify</a>
          </div>
          
          
        </div>
        <!-- <div class="all-in d-flex flex-row">
          <div class="left-block d-flex flex-column align-items-center">
           <i class="fal fa-home"></i>
            <div class="line-icon"> </div>
          </div>
          <div class="right-block d-flex flex-column">
            <h1>Delivery Address</h1>
            <p>Select a valid payment method to continue.</p>
            
          </div>
          <div class="modify_link d-flex">
            <a href="#" @click="modifyAddress">Modify</a>
          </div>
          
          
        </div> -->
       
      </div>
       <!-- <div class="total d-flex flex-row justify-content-around align-items-center" v-if="info.method && info.when">
        <h1>Total</h1>
        <h1>${{info.sum}}</h1>
        
      </div> -->
      <div class="mobile-header justify-content-center align-items-center">
      <i class="fal fa-times" @click="changeState"></i>
    </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import creditCardType from 'credit-card-type';
export default {
    name: 'sideBar',
    data(){
        return{

        }
    },
    computed: {
        ...mapState(['info']),
        asap: function(){
            // let today = new Date();
            // let tmp = this.info.basket.earliestreadytime;
            // tmp = tmp.slice(0, 4) + "/" + tmp.slice(4, 6) + "/" + tmp.slice(6, 8) + " " + tmp.slice(9) + ":00";
            // var diff = Math.abs(new Date() - new Date(tmp));
            // return Math.floor(diff / 1000 / 60);
            return '15 - 20';
        },
        isSchedulePage(){
          return this.$route.path === '/'
        },
        isSearchPage(){
          return this.$route.path === '/search'
        },
        isOrderPage(){
          return this.$route.path === '/order';
        },
        isPaymentPage(){
          return this.$route.path === '/payment';
        },
        isSearch(){
          return this.$route.path === '/search';
        }
    },
    methods: {
      trashProduct(index){
          this.$store.commit('product.delete', index)
      },

        modifyAddress(){
            //this.$store.commit('clear');
            this.$router.push({ name: 'search'});
        },
        modifyDelivery(){
            this.$router.push({ name: 'schedule'});
            this.$emit('change');
        },
        modifyOrder(){
            this.$router.push({ name: 'order'});
            this.$emit('change');
        },
        modifyCard(){
            this.$router.push({ name: 'payment'});
            this.$emit('change');
        },
        changeState(){
            this.$emit('change');
        },
        getCardInfo(cardnumber){
          let type = creditCardType(cardnumber)
          return type[0]
        }
    }
}
</script>
<style scoped>
.mainBlock{
  width:100%;
}
.total h1{
  
	opacity: 0.8;
	color: #000000;
	font-family: Poppins;
	font-size: 20px;
	font-weight: bold;
	line-height: 25px;

}
.total
{
  position: fixed;
  bottom: 0;
  left: 0;
	height: 154px;
	width: 480px;
	border: 1px solid rgba(0,0,0,0.05);
	background-color: rgba(0,0,0,0.05);
}


.predescription i
{
 
	opacity: 0.4;
	color: #000000;
	font-family: "Font Awesome 5 Pro";
	font-size: 13px;
	line-height: 13px;
}
.predescription span:last-child
{
  
	opacity: 0.4;
	color: #000000;
	font-family: Poppins;
	font-size: 13px;
	font-weight: 500;
	line-height: 20px;

}
.predescription .preTitle
{
 
	opacity: 0.6;
	color: #000000;
	font-family: Poppins;
	font-size: 13px;
	font-weight: 500;
	line-height: 15px;
  text-decoration: underline;
}
.predescription .preInfo{
  
	opacity: 0.4;
	color: #000000;
	font-family: Poppins;
	font-size: 11px;
	font-weight: 500;
	line-height: 17px;

}
.predescription .count
{
  
	opacity: 0.4;
	color: #000000;
	font-family: Poppins;
	font-size: 13px;
	font-weight: 500;
	line-height: 20px;
	text-align: left;
  padding-right: 10px;

}
/* .predescription
{
  width: 250px !important;
} */

/* .predescription div p
{
  width: 130px !important;
} */
.container-property .all-in:nth-child(2)
{
  /* padding-top: 33px; */
}
.container-property .all-in
{
  position: relative;
  padding-top: 10px;
}


.left-block {
  /* width: 20%; */
}
.left-block i {
  height: 21px;
  width: 28px;
  opacity: 0.8;
  color: #000000;
  font-family: "Font Awesome 5 Pro";
  font-size: 20px;
  font-weight: 300;
  line-height: 21px;
  text-align: center;
}
.line-icon
{
	box-sizing: border-box;
	height: 82px;
	width: 1px;
	border: 1px solid #000000;
	opacity: 0.1;
  margin-top: 8px;
}
.right-block {
  width: 80%;
  padding-left:16px;
}
.right-block h1 {
  /* height: 32px; */
  width: 155px;
  opacity: 0.8;
  color: #000000;
  font-family: Poppins;
  font-size: 16px;
  font-weight: bold;
  line-height: 18px;
  margin-bottom: 8px;
}



.right-block p {
  opacity: 0.6;
  color: #000000;
  font-family: Poppins;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  margin: 0 ;
  width: 200px;
}
.container-property .all-in:nth-child(3) .right-block h1{
margin-bottom: 8px;
}
.modify_link {
  position:absolute;
  right: 0px;
  top:5px;
  /* width: 10%; */
  /* padding-left: 10%; */
}
.modify_link a {
  opacity: 0.4;
  color: #000000;
  font-family: Poppins;
  font-size: 12px;
  font-weight: 500;
  line-height: 25px;
  text-align: right;
  text-decoration: underline;
}
.container-property {
  width: 100%;
  padding: 33px;
}

.title {
  font-family: "Poppins", sans-serif;
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
  opacity: 0.8;
  line-height: 26px;
  color: #000000;
  text-align: left;
}
.subTitle {
  font-family: "Poppins", sans-serif;
  font-size: 12px;
  font-weight: 500;
  text-transform: capitalize;
  opacity: 0.4;
  /* line-height: 20px; */
  color: #000000;
  text-align: left;
}
.logo-title {
  padding: 15px 15px;
  border: 1.5px solid rgba(0, 0, 0, 0.05);
}

.logo-title img {
  width: 50px;
  height: 50px;
  float: left;
}
button {
  border: none;
  background: none;
}
.order-block {
  /* height: 100vh; */
  /* width: 322px; */
  width:400px;
  /* width: 480px; */
  border-right: 1.5px solid rgba(0, 0, 0, 0.05);
  background-color: #ffffff;
  /* overflow-y: scroll !important; */
  /* padding-right:60px */
}
.title-property {
  text-transform: uppercase;
  opacity: 0.4;
  color: #000000;
  font-family: Poppins;
  font-size: 16px;
  font-weight: bold;
  line-height: 25px;
  margin-bottom: 32px;
}
.mobile-header {
  display: none;
  /* position: fixed;
  bottom:0px;
  z-index: 6; */
  box-sizing: border-box;
  height: 62px;
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.05);
  /* border-radius: 30px; */
  background-color: #ffffff;
  justify-content: center;
  align-items: center;
  box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.15);
  padding: 15px 17px;
}
.mobile-header i{
  font-size: 30px;
}
button {
  border: none;
  background: none;
}
.container-number {
  width: 50%;
}
.lastnum {
  opacity: 0.6;
  color: #000000;
  font-family: Poppins;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  margin-left: 5px;
}
.dot {
  -moz-border-radius: 50px/50px;
  -webkit-border-radius: 50px 50px;
  border-radius: 50px/50px;
  border: 2px solid rgba(0, 0, 0, 0.6);
  background-color: #ffffff;
  width: 5px;
  height: 5px;
  margin-left: 1px;
  opacity: 0.6;
}

@media screen and (max-width: 600px) {
    .order-block
    {
      width: 100%;
      height: 100%;
    }
    .logo-title
    {
      width: 100%;
    }
    .mainBlock
    {
      width: 100%;
    }
     .mobile-header {
    display: flex;
    position: fixed;
    z-index: 10;
    bottom: 0px;
      padding:15px 17px !important
    /* transform: translate(40%, 30%); */
  }
  .total
  {
    top:8px;
    position: relative;
    width: 100%;
    margin-bottom:62px;
  }
  .container-property
  {
    padding: 20px
  }
  
 
}
</style>



// WEBPACK FOOTER //
// src/components/sideBar.vue